import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { OperatorFaqQueryInput, PaginatedOperatorFaqTypeResponse } from '@/models/operatorFaq';

export const fetchOperatorFaqs = async ({
  query,
  orderBy,
  sortType,
  pagination,
}: OperatorFaqQueryInput): Promise<PaginatedOperatorFaqTypeResponse> => {
  const response = await queryExecute({
    query: graphql(`
      query OperatorFaqs($query: String, $orderBy: String, $sortType: String, $pagination: PaginationInputType) {
        operatorFaqs(query: $query, orderBy: $orderBy, sortType: $sortType, pagination: $pagination) {
          count
          rows {
            id
            categories
            answer
            question
            relatedQuestions
            operator {
              firstName
              lastName
            }
            changes {
              id
              user {
                firstName
                lastName
              }
              oldText
              newText
              createdAt
            }
            createdAt
          }
        }
      }
    `),
    fetchPolicy: 'no-cache',
    variables: {
      query,
      orderBy,
      sortType,
      pagination,
    },
  });

  return response.data.operatorFaqs;
};
